import { generateClient } from 'aws-amplify/api'
import {
  ListOrgUsers as listOrgUsersQuery,
} from '@/graphql/queries'
import {
  CreateOrgUser as createOrgUserMutation,
  UpdateOrgUser as updateOrgUserMutation,
  DeleteOrgUser as deleteOrgUserMutation,
  ResetOrgUserPassword as resetOrgUserPasswordMutation,
} from '@/graphql/mutations'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'
import {
  buildCreateOrgUserInput,
  buildUpdateOrgUserInput,
  validateCreateOrgUserForm,
} from '@/utils/orgUsers'

const client = generateClient()

async function runUsersField(document, field, input) {
  try {
    const { data, errors } = await client.graphql({
      query: document,
      variables: { input },
    })

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return parseAwsJson(data?.[field])
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Request failed'),
    }
  }
}

export function fetchOrgUsers(input = {}) {
  return runUsersField(listOrgUsersQuery, 'ListOrgUsers', input)
}

export function createOrgUser(input) {
  const validation = validateCreateOrgUserForm(input)
  if (!validation.valid) {
    const firstError = Object.values(validation.errors)[0]
    return Promise.resolve({
      status: 'ERROR',
      message: firstError || 'Please complete all required fields.',
    })
  }

  return runUsersField(
    createOrgUserMutation,
    'CreateOrgUser',
    buildCreateOrgUserInput(input),
  )
}

export function updateOrgUser(input) {
  return runUsersField(
    updateOrgUserMutation,
    'UpdateOrgUser',
    buildUpdateOrgUserInput(input),
  )
}

export function deleteOrgUser(input) {
  return runUsersField(deleteOrgUserMutation, 'DeleteOrgUser', input)
}

export function resetOrgUserPassword(input) {
  return runUsersField(resetOrgUserPasswordMutation, 'ResetOrgUserPassword', input)
}
